/* Add All Action constants here  */

const ACTION_TYPES = {
  APP: {
    LOGOUT: "LOGOUT",
    SET_LOADING: "SET_LOADING",
    SET_IS_LOGIN: "SET_IS_LOGIN",
    USER_ON_DASHBOARD: "USER_ON_DASHBOARD",
    USER_CURRENT_SCREEN: "USER_CURRENT_SCREEN",
    SELECTED_RISK_INDEX: 'SELECTED_RISK_INDEX',
    SET_REQUEST_ID: 'SET_REQUEST_ID',
    LOGIN: {
      INIT: "LOGIN_INIT",
      SUCCESS: "LOGIN_SUCCESS",
      FAIL: "LOGIN_FAIL",
    },
    USER_PROFILE: {
      INIT: "USER_PROFILE_INIT",
      SUCCESS: "USER_PROFILE_SUCCESS",
      FAIL: "USER_PROFILE_FAIL",
    },
    DASHBOARD: {
      INIT: "DASHBOARD_INIT",
      SUCCESS: "DASHBOARD_SUCCESS",
      FAIL: "DASHBOARD_FAIL",
    },
  },
  AUTH: {
    LOADING: "AUTH_LOADING",
  },
};

export { ACTION_TYPES };
